/*
 * @Author: Craft
 * @Date: 2024-01-07
 */
import { Data } from '@/api/axiosFun.js';

class CyclingApi {
    static getInstance() {
        if (!this.instance) this.instance = new CyclingApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取车辆数据列表
    async getList(param, page_num, page_size){
        let url = `/api/sys/v2/vehicle/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取车辆数据列表, 获取车架号、电机总成
    async getFrameAndMotor(param, page_num, page_size){
        let url = `/api/sys/v2/vehicle/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    async getFrameAndMotorQuery(param){
        let url = `/api/sys/v2/vehicle/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取全部用户总里程区间人数
    async getAllUserMileageZoneCount(param, tenant_id){
        let url = tenant_id == null? `/api/sys/vehicle/cyclingMileage/count` : `/api/sys/vehicle/cyclingMileage/count?tenant_id=${tenant_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载全部用户总里程区间人数
    async downloadAllUserMileageZoneCount(param){
        let url = `/api/sys/vehicle/cyclingMileage/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取骑行次数
    async getRideCount(param, tenant_id){
        let url = tenant_id == null? `/api/sys/vehicle/ride/count` : `/api/sys/vehicle/ride/count?tenant_id=${tenant_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }

     // 下载骑行次数
     async downloadRideCount(param){
        let url = `/api/sys/vehicle/ride/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取单个用户骑行数据
    async getUserCyclingData(param){
        let url = `/api/sys/ride/state/group/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

     // 下载单个用户骑行数据-列表
     async downloadUserCyclingListData(param){
        let url = `/api/sys/vehicle/riding/total/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载单个用户骑行数据-图表
    async downloadUserCyclingData(param){
        let url = `/api/sys/ride/state/group/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取车辆总里程-排行榜
    async getVehicleMileage(param){
        let url = `/api/sys/v2/vehicle/top/vehicle/mileage`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取用户总里程-排行榜
    async getCyclingMileage(param){
        let url = `/api/sys/v2/vehicle/top/cycling/mileage`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 下载骑行总里程、电机总里程-排行榜
    async downloadMileage(sys_org){
        let url = `/api/sys/v2/vehicle/mileage/download?sys_org=${sys_org}`
        let result = await this.getData(url,{},'POST')
        return result
    }
}

export {
    CyclingApi
}